<template>
  <Swiper :options="swiperOption">
    <SwiperSlide class="slider_swiper" v-for="card in cards" :key="card.cardCode">
      <RouterLink
        class="slider_link"
        active-class="slider_link__active"
        :to="{ name: 'card_detail', params: { cardCode: card.cardCode } }"
        @click.native="onCardClick(card)"
      >
        <CardPicture
          :design="card.currentDesign"
          :game="card.currentGame"
          :inactive="card.status === 'unbound'"
          preview
        />
      </RouterLink>
    </SwiperSlide>
  </Swiper>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { swiper as Swiper, swiperSlide as SwiperSlide } from 'vue-awesome-swiper'

import CardPicture from './Card/CardPicture.vue'

@Component({
  components: { Swiper, SwiperSlide, CardPicture }
})
class CardSwitcher extends Vue {
  @Prop({ type: Array, required: true }) cards

  swiperOption = {
    slidesPerView: 'auto',
    spaceBetween: 6,
    watchOverflow: true,
    threshold: 5
  }

  onCardClick (card) {
    this.$emit('card-change', card)
  }
}

export default CardSwitcher
</script>

<style>

</style>
